import { action } from '@ember/object';
import IndexController from 'cio/pods/segments/segment/overview/index/controller';
import { inject as controller } from '@ember/controller';
import serialize from 'cio/utils/conditions/serialize';
import { inject as service } from '@ember/service';
import { Entities, MetricTypes } from 'cio/utils/metrics/common';
import { task } from 'ember-concurrency';
import { reject } from 'rsvp';
import { isNone } from '@ember/utils';
import MetricsService from 'cio/services/metrics';
import RouterService from '@ember/routing/router-service';
import AnalyticsService from 'cio/services/analytics';
import ApiErrorsService from 'cio/services/api-errors';
import SegmentController from '../../controller';

export default class EditController extends IndexController {
  @service('metrics') metricsService!: MetricsService;
  @service router!: RouterService;
  @service analytics!: AnalyticsService;
  @service apiErrors!: ApiErrorsService;

  @controller('segments.segment') segmentController!: SegmentController;

  get isDirty() {
    return this.conditionTree?.isDirty ?? false;
  }

  saveConditions = task(async () => {
    let { model, conditionTree } = this;

    if (conditionTree == null || !conditionTree.validate()) {
      return reject();
    }

    model.set('conditions', serialize(conditionTree));

    try {
      await model.save();
      this.metricsService.clearMetrics(MetricTypes.SegmentMembershipMetric, Entities.SEGMENT, model.id);
      this.extractConditionTree();
      this.segmentController.pollForBuildFinish.perform();
      this.router.transitionTo('segments.segment.overview.index');
    } catch (adapterError) {
      if (!isNone(adapterError)) {
        this.apiErrors.report(adapterError);
      }
      model.rollbackAttributes();
    }
  });

  @action
  resetConditions() {
    this.extractConditionTree();
    this.router.transitionTo('segments.segment.overview.index');
  }
}

declare module '@ember/controller' {
  interface Registry {
    'segments.segment.overview.edit': EditController;
  }
}
